import Vue from 'vue';
import defaultState from './defaultState';
import * as C from '../../constants';

export default {
  [C.SKI_SKISTAR_CLEAR_STATE](state) {
    Object.assign(state, defaultState());
  },

  // region RESORT
  [C.SKI_SKISTAR_RESORT_LOAD_PENDING](state) {
    Vue.set(state, 'resorts', {
      ...state.resorts,
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.SKI_SKISTAR_RESORT_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'resorts', {
      ...state.resorts,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.SKI_SKISTAR_RESORT_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'resorts', {
      ...state.resorts,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.SKI_SKISTAR_RESORT_CHANGE](state, payload) {
    Vue.set(state, 'resorts', {
      ...state.resorts,
      resort: payload,
    });
  },

  [C.SKI_SKISTAR_RESORT_WEBSERVICE_CHANGE](state, payload) {
    Vue.set(state, 'resorts', {
      ...state.resorts,
      webservice: payload,
    });
  },
  // endregion RESORT

  // region SUBAREA
  [C.SKI_SKISTAR_RESORT_SUBAREAS_PENDING](state) {
    Vue.set(state.resorts, 'subarea', {
      ...state.resorts.subarea,
      itemsLoading: true,
      itemsError: undefined,
      selected: undefined,
    });
  },

  [C.SKI_SKISTAR_RESORT_SUBAREAS_FAILURE](state, payload) {
    Vue.set(state.resorts, 'subarea', {
      ...state.resorts.subarea,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.SKI_SKISTAR_RESORT_SUBAREAS_SUCCESS](state, payload) {
    Vue.set(state.resorts, 'subarea', {
      ...state.resorts.subarea,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.SKI_SKISTAR_RESORT_SUBAREA_CHANGE](state, payload) {
    Vue.set(state.resorts, 'subarea', {
      ...state.resorts.subarea,
      selected: payload,
    });
  },
  // endregion SUBAREA

  // region AREAS
  [C.SKI_SKISTAR_ACCOMMODATIONS_LOAD_PENDING](state) {
    Vue.set(state, 'accommodations', {
      ...state.accommodations,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATIONS_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'accommodations', {
      ...state.accommodations,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATIONS_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'accommodations', {
      ...state.accommodations,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.SKI_SKISTAR_SUBAREAS_SET](state, payload) {
    Vue.set(state.accommodations, 'subareas', payload);
  },

  [C.SKI_SKISTAR_SUBAREA_CHANGE](state, payload) {
    Vue.set(state.accommodations, 'subarea', payload);
  },

  [C.SKI_SKISTAR_AREAS_SEARCH](state, payload) {
    Vue.set(state.accommodations, 'search', payload);
  },
  // endregion AREAS

  // region SUPPLIER
  [C.SKI_SKISTAR_SUPPLIER_LOAD_PENDING](state) {
    Vue.set(state.suppliers, 'itemsLoading', true);
  },

  [C.SKI_SKISTAR_SUPPLIER_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'suppliers', {
      ...state.suppliers,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.SKI_SKISTAR_SUPPLIER_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'suppliers', {
      ...state.suppliers,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_SUPPLIER_CHANGE](state, payload) {
    Vue.set(state.suppliers, 'supplier', payload);
  },
  // SUPPLIER END

  // region SITE
  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_SITE_CHANGE](state, payload) {
    Vue.set(state.sites, 'site', payload);
  },

  [C.SKI_SKISTAR_SITES_LOAD_PENDING](state) {
    Vue.set(state.sites, 'itemsLoading', true);
  },

  [C.SKI_SKISTAR_SITES_LOAD_FAILURE](state, payload) {
    Vue.set(state, 'sites', {
      ...state.sites,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.SKI_SKISTAR_SITES_LOAD_SUCCESS](state, payload) {
    Vue.set(state, 'sites', {
      ...state.sites,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },
  // endregion SITE

  // region ACCOMMODATION
  [C.SKI_SKISTAR_ACCOMMODATION_TEXTS_PENDING](state, payload) {
    Vue.set(state.accommodation, 'selected', payload);
    Vue.set(state.accommodation, 'texts', {
      ...state.accommodation.texts,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
      show: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_TEXTS_SUCCESS](state, payload) {
    Vue.set(state.accommodation, 'texts', {
      ...state.accommodation.texts,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
      show: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_TEXTS_NOCONTENT](state) {
    Vue.set(state.accommodation, 'texts', {
      ...state.accommodation.texts,
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      show: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_TEXTS_FAILURE](state, payload) {
    Vue.set(state.accommodation, 'texts', {
      ...state.accommodation.texts,
      items: [],
      itemsLoading: false,
      itemsError: payload,
      show: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_TEXTS_CLOSE](state) {
    Vue.set(state.accommodation, 'texts', {
      ...state.accommodation.texts,
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      show: false,
    });
    Vue.set(state.accommodation, 'id', undefined);
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGES_PENDING](state, payload) {
    Vue.set(state.accommodation, 'selected', payload);
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      items: {},
      itemsLoading: true,
      itemsError: undefined,
      show: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGES_SUCCESS](state, payload) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
      show: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGES_NOCONTENT](state) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.texts,
      items: {},
      itemsLoading: false,
      itemsError: undefined,
      show: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGES_FAILURE](state, payload) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      items: {},
      itemsLoading: false,
      itemsError: payload,
      show: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGES_CLOSE](state) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      items: {},
      itemsLoading: false,
      itemsError: undefined,
      show: false,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_PENDING](state) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      itemsLoading: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_SUCCESS](state, identifier) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      itemsLoading: false,
    });
    Vue.set(state.accommodation.images.items[identifier], 'active', true);
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGE_ACTIVATE_FAILURE](state, payload) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_PENDING](state) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      itemsLoading: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_SUCCESS](state, identifier) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      itemsLoading: false,
    });
    Vue.set(state.accommodation.images.items[identifier], 'active', false);
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DEACTIVATE_FAILURE](state, payload) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_PENDING](state) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      itemsLoading: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_SUCCESS](state, identifier) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      itemsLoading: false,
    });
    Vue.set(state.accommodation.images.items[identifier], 'isImportedToTwenty', false);
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMAGE_DELETE_FAILURE](state, payload) {
    Vue.set(state.accommodation, 'images', {
      ...state.accommodation.images,
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_PENDING](state) {
    Vue.set(state, 'import', {
      ...state.import,
      loading: true,
      error: undefined,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_SUCCESS](state) {
    Vue.set(state, 'import', {
      ...state.import,
      loading: false,
      error: undefined,
    });
    Vue.set(state.sites, 'site', undefined);
  },

  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_FAILURE](state, payload) {
    Vue.set(state, 'import', {
      ...state.import,
      loading: false,
      error: payload,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_SELECTION_REMOVE](state, index) {
    state.accommodations.selected.splice(index, 1);
  },

  [C.SKI_SKISTAR_ACCOMMODATION_SELECTION_ADD](state, id) {
    state.accommodations.selected.push(id);
  },

  [C.SKI_SKISTAR_ACCOMMODATION_SELECTION_TOGGLE_ALL](state, payload) {
    Vue.set(state.accommodations, 'selected', payload);
  },

  [C.SKI_SKISTAR_ACCOMMODATION_SELECTION_REMOVE_IMPORTED](state, payload) {
    Vue.set(state.accommodations, 'selected', payload);
  },

  [C.SKI_SKISTAR_ACCOMMODATION_UNMAP_DIALOG](state, payload) {
    Vue.set(state.accommodations, 'unmap', payload);
  },

  [C.SKI_SKISTAR_ACCOMMODATION_UNMAP_RESET](state) {
    Vue.set(state, 'accommodations', {
      ...state.accommodations,
      unmap: undefined,
      unmapLoading: false,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_UNMAP_PENDING](state) {
    Vue.set(state, 'accommodations', {
      ...state.accommodations,
      unmapLoading: true,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_UNMAP_SUCCESS](state) {
    Vue.set(state, 'accommodations', {
      ...state.accommodations,
      unmap: undefined,
      unmapLoading: false,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_UNMAP_FAILURE](state) {
    Vue.set(state, 'accommodations', {
      ...state.accommodations,
      unmap: undefined,
      unmapLoading: false,
    });
  },

  [C.SKI_SKISTAR_ACCOMMODATION_FILTER_IMPORT_STATUS_CHANGE](state, payload) {
    Vue.set(state.accommodations, 'filterImportStatus', payload);
  },

  [C.SKI_SKISTAR_ACCOMMODATION_FILTER_IMAGE_STATUS_CHANGE](state, payload) {
    Vue.set(state.accommodations, 'filterImageStatus', payload);
  },
  // endregion ACCOMMODATION

  // region IMPORT STATUS
  [C.SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_PENDING](state) {
    Vue.set(state.import, 'status', {
      ...state.import.status,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_SUCCESS](state, payload) {
    Vue.set(state.import, 'status', {
      ...state.import.status,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_NO_CONTENT](state) {
    Vue.set(state.import, 'status', {
      ...state.import.status,
      items: [],
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.SKI_SKISTAR_STOCK_PRICE_PRODUCTS_LOAD_FAILURE](state, payload) {
    Vue.set(state.import, 'status', {
      ...state.import.status,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },
  // endregion IMPORT STATUS

  // region ACCOMMODATION CATEGORIES
  [C.SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_PENDING](state) {
    Vue.set(state.accommodations, 'categories', {
      ...state.accommodations.categories,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    });
  },
  [C.SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_SUCCESS](state, payload) {
    Vue.set(state.accommodations, 'categories', {
      ...state.accommodations.categories,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },
  [C.SKI_SKISTAR_ACCOMMODATION_CATEGORIES_LOAD_FAILURE](state, payload) {
    Vue.set(state.accommodations, 'categories', {
      ...state.accommodations.categories,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },
  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_CATEGORY_CHANGE](state, payload) {
    Vue.set(state.accommodations.categories, 'category', payload);
  },
  // endregion ACCOMMODATION CATEGORIES

  // region ADDONS
  [C.SKI_SKISTAR_ADDONS_RESORT_LIST_PENDING](state) {
    Vue.set(state, 'addons', {
      ...state.addons,
      items: [],
      itemsLoading: true,
      itemsError: undefined,
    });
  },

  [C.SKI_SKISTAR_ADDONS_RESORT_LIST_FAILURE](state, payload) {
    Vue.set(state, 'resorts', {
      ...state.addons,
      items: [],
      itemsLoading: false,
      itemsError: payload,
    });
  },

  [C.SKI_SKISTAR_ADDONS_RESORT_LIST_SUCCESS](state, payload) {
    Vue.set(state, 'addons', {
      ...state.addons,
      items: payload,
      itemsLoading: false,
      itemsError: undefined,
    });
  },

  [C.SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_PENDING](state, id) {
    Vue.set(state.addons.updateInProgressItems, id, true);
    Vue.set(state.addons.updateErrorItems, id, undefined);
  },

  [C.SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_SUCCESS](state, addon) {
    Vue.set(state, 'addons', {
      ...state.addons,
      updateInProgress: false,
      updateError: undefined,
    });
    Vue.set(state.addons.items[addon.index], 'twentyExtraId', addon.twentyExtraId);
    Vue.set(state.addons.updateInProgressItems, addon.id, false);
  },

  [C.SKI_SKISTAR_ADDONS_RESORT_TWENTY_EXTRA_UPDATE_FAILURE](state, payload) {
    Vue.set(state, 'addons', {
      ...state.addons,
      updateInProgress: false,
      updateError: payload,
    });
    Vue.set(state.addons.updateErrorItems, payload.id, payload.error);
  },

  [C.SKI_SKISTAR_ADDONS_RESORT_ACCOMMODATION_MODAL_SHOW](state, addon) {
    Vue.set(state.addons, 'addon', {
      ...state.addons.addon,
      showAccommodations: true,
      id: addon.id,
      description: addon.description,
      accommodations: addon.accommodations,
    });
  },

  [C.SKI_SKISTAR_ADDONS_RESORT_ACCOMMODATION_MODAL_CLOSE](state) {
    Vue.set(state.addons, 'addon', {
      ...state.addons.addon,
      showAccommodations: false,
      id: undefined,
      description: undefined,
      accommodations: undefined,
    });
  },

  [C.SKI_SKISTAR_ADDONS_RESORT_SEARCH](state, payload) {
    Vue.set(state.addons, 'search', payload);
  },
  // endregion ADDONS

  // region IMPORT STATUS
  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_SHOW](state, payload) {
    Vue.set(state.accommodation, 'selected', payload);
    Vue.set(state.accommodation, 'importStatus', {
      ...state.accommodation.importStatus,
      importedAccommodation: undefined,
      show: true,
      loading: true,
      error: undefined,
    });
  },
  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_ACCOMMODATION_SUCCESS](state, payload) {
    Vue.set(state.accommodation, 'importStatus', {
      ...state.accommodation.importStatus,
      importedAccommodation: payload,
      loading: false,
    });
  },
  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_ACCOMMODATION_FAILURE](state, payload) {
    Vue.set(state.accommodation, 'importStatus', {
      ...state.accommodation.importStatus,
      importedAccommodation: undefined,
      loading: false,
      error: payload,
    });
  },
  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_CLOSE](state) {
    Vue.set(state.accommodation, 'selected', undefined);
    Vue.set(state.accommodation, 'importStatus', {
      ...state.accommodation.importStatus,
      importedAccommodation: undefined,
      show: false,
      loading: false,
      error: undefined,
    });
  },
  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_PENDING](state) {
    Vue.set(state.accommodation.importStatus, 'updateInProgress', true);
  },
  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_SUCCESS](state) {
    Vue.set(state.accommodation.importStatus, 'updateInProgress', false);
  },
  [C.SKI_SKISTAR_ACCOMMODATION_IMPORT_STATUS_UPDATE_SITE_FAILURE](state, payload) {
    Vue.set(state.accommodation.importStatus, 'updateInProgress', false);
    Vue.set(state.accommodation.importStatus, 'error', payload);
  },
  // endregion IMPORT STATUS
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/skistar/mutations.js